// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-layout {
  min-height: 100vh;
  background: var(--color-bg);
}

/* 主要游戏区域 */
.games-main {
  width: 100%;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.games-grid {
  margin-bottom: 40px;
}

/* 列表中的广告位样式 */
.ad-in-list {
  margin: 20px 0;
  padding: 16px;
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  text-align: center;
}

.ad-in-list .ad-container {
  margin: 0;
}

.ad-in-list .ad-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90px;
}

/* 滚动加载指示器 */
.scroll-loading-container {
  text-align: center;
  padding: 20px 0;
  margin: 20px 0;
}

.scroll-loading-container .loading-text {
  margin-top: 12px;
  color: #666;
  font-size: 14px;
}

.category-content {
  padding: 12px 0;
  min-height: calc(100vh - 200px);
}

/* 移动端和PAD端使用固定高度布局 */
@media (max-width: 768px) {
  .category-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .category-content {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .category-container {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

.category-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.category-header {
  margin-bottom: 32px;
  text-align: center;
}

.page-title {
  color: #2D3436;
  font-weight: 700;
  margin-bottom: 8px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.page-title .anticon {
  color: #6C5CE7;
  font-size: 28px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
}

.categories-section {
  margin-bottom: 48px;
}

.category-card-link {
  display: block;
  color: inherit;
  text-decoration: none;
}

.category-card-link:hover {
  color: inherit;
}

.category-card {
  border-radius: 16px !important;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-card:hover {
  border-color: #6C5CE7;
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(108, 92, 231, 0.15);
}

.category-card-active {
  border-color: #6C5CE7 !important;
  background: linear-gradient(135deg, #6C5CE7 0%, #A29BFE 100%);
}

.category-card-active .category-card-content {
  color: white;
}

.category-card-content {
  text-align: center;
  padding: 16px;
}

.category-icon {
  font-size: 32px;
  color: #6C5CE7;
  margin-bottom: 12px;
  display: block;
}

.category-card-active .category-icon {
  color: white;
}

.category-name {
  font-size: 14px;
  font-weight: 600;
  color: #2D3436;
  line-height: 1.4;
}

.category-card-active .category-name {
  color: white;
}

.category-apps-section {
  margin-top: 0;
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.section-title {
  color: #2D3436;
  font-weight: 600;
  margin-bottom: 24px !important;
  padding-bottom: 12px;
  border-bottom: 2px solid #6C5CE7;
  display: inline-block;
}

/* Mobile and Tablet Responsive */
@media (max-width: 768px) {
  .category-container {
    padding: 0 16px;
  }

  .category-header {
    margin-bottom: 24px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-title .anticon {
    font-size: 24px;
  }

  .categories-section {
    display: none;
  }

  .category-card {
    height: 100px;
  }

  .category-icon {
    font-size: 28px;
    margin-bottom: 8px;
  }

  .category-name {
    font-size: 13px;
  }

  .category-apps-section {
    margin-top: 0;
  }

  .section-title {
    font-size: 18px;
    margin-bottom: 16px !important;
  }

  .category-apps-section > .homepage-ad {
    margin-bottom: 4px;
  }
  
  .games-main {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 24px 0;
    padding-top: 8px;
  }
}

@media (max-width: 480px) {
  .category-content {
    padding: 12px 0;
  }

  .category-container {
    padding: 0 12px;
  }

  .category-header {
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 20px;
  }

  .page-title .anticon {
    font-size: 20px;
  }

  .category-card {
    height: 80px;
  }

  .category-card-content {
    padding: 12px;
  }

  .category-icon {
    font-size: 24px;
    margin-bottom: 6px;
  }

  .category-name {
    font-size: 12px;
  }

  .section-title {
    font-size: 16px;
  }
}

/* 添加移动端专用类 */
@media (min-width: 769px) {
  .mobile-only {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Category/Category.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,aAAa;AACb;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".category-layout {\n  min-height: 100vh;\n  background: var(--color-bg);\n}\n\n/* 主要游戏区域 */\n.games-main {\n  width: 100%;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.games-grid {\n  margin-bottom: 40px;\n}\n\n/* 列表中的广告位样式 */\n.ad-in-list {\n  margin: 20px 0;\n  padding: 16px;\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n  text-align: center;\n}\n\n.ad-in-list .ad-container {\n  margin: 0;\n}\n\n.ad-in-list .ad-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 90px;\n}\n\n/* 滚动加载指示器 */\n.scroll-loading-container {\n  text-align: center;\n  padding: 20px 0;\n  margin: 20px 0;\n}\n\n.scroll-loading-container .loading-text {\n  margin-top: 12px;\n  color: #666;\n  font-size: 14px;\n}\n\n.category-content {\n  padding: 12px 0;\n  min-height: calc(100vh - 200px);\n}\n\n/* 移动端和PAD端使用固定高度布局 */\n@media (max-width: 768px) {\n  .category-layout {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .category-content {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .category-container {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.category-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.category-header {\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.page-title {\n  color: #2D3436;\n  font-weight: 700;\n  margin-bottom: 8px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n}\n\n.page-title .anticon {\n  color: #6C5CE7;\n  font-size: 28px;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 60px 0;\n}\n\n.categories-section {\n  margin-bottom: 48px;\n}\n\n.category-card-link {\n  display: block;\n  color: inherit;\n  text-decoration: none;\n}\n\n.category-card-link:hover {\n  color: inherit;\n}\n\n.category-card {\n  border-radius: 16px !important;\n  border: 2px solid transparent;\n  transition: all 0.3s ease;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.category-card:hover {\n  border-color: #6C5CE7;\n  transform: translateY(-4px);\n  box-shadow: 0 8px 24px rgba(108, 92, 231, 0.15);\n}\n\n.category-card-active {\n  border-color: #6C5CE7 !important;\n  background: linear-gradient(135deg, #6C5CE7 0%, #A29BFE 100%);\n}\n\n.category-card-active .category-card-content {\n  color: white;\n}\n\n.category-card-content {\n  text-align: center;\n  padding: 16px;\n}\n\n.category-icon {\n  font-size: 32px;\n  color: #6C5CE7;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.category-card-active .category-icon {\n  color: white;\n}\n\n.category-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2D3436;\n  line-height: 1.4;\n}\n\n.category-card-active .category-name {\n  color: white;\n}\n\n.category-apps-section {\n  margin-top: 0;\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.section-title {\n  color: #2D3436;\n  font-weight: 600;\n  margin-bottom: 24px !important;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #6C5CE7;\n  display: inline-block;\n}\n\n/* Mobile and Tablet Responsive */\n@media (max-width: 768px) {\n  .category-container {\n    padding: 0 16px;\n  }\n\n  .category-header {\n    margin-bottom: 24px;\n  }\n\n  .page-title {\n    font-size: 24px;\n  }\n\n  .page-title .anticon {\n    font-size: 24px;\n  }\n\n  .categories-section {\n    display: none;\n  }\n\n  .category-card {\n    height: 100px;\n  }\n\n  .category-icon {\n    font-size: 28px;\n    margin-bottom: 8px;\n  }\n\n  .category-name {\n    font-size: 13px;\n  }\n\n  .category-apps-section {\n    margin-top: 0;\n  }\n\n  .section-title {\n    font-size: 18px;\n    margin-bottom: 16px !important;\n  }\n\n  .category-apps-section > .homepage-ad {\n    margin-bottom: 4px;\n  }\n  \n  .games-main {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 24px 0;\n    padding-top: 8px;\n  }\n}\n\n@media (max-width: 480px) {\n  .category-content {\n    padding: 12px 0;\n  }\n\n  .category-container {\n    padding: 0 12px;\n  }\n\n  .category-header {\n    margin-bottom: 20px;\n  }\n\n  .page-title {\n    font-size: 20px;\n  }\n\n  .page-title .anticon {\n    font-size: 20px;\n  }\n\n  .category-card {\n    height: 80px;\n  }\n\n  .category-card-content {\n    padding: 12px;\n  }\n\n  .category-icon {\n    font-size: 24px;\n    margin-bottom: 6px;\n  }\n\n  .category-name {\n    font-size: 12px;\n  }\n\n  .section-title {\n    font-size: 16px;\n  }\n}\n\n/* 添加移动端专用类 */\n@media (min-width: 769px) {\n  .mobile-only {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
